module.exports = __webpack_public_path__ + "img/superMestoTxt.b2ef38ae.svg";